import { createSelector } from 'reselect';

export const getMappedUsers = (state) => state.ad.users;
export const getUsers = createSelector(getMappedUsers, (mappedUsers) =>
  Object.values(mappedUsers).toSorted((a, b) => (a.name || '').localeCompare(b.name || ''))
);

export const getLimitedUsers = createSelector(
  (state) => state.ad.limitedUsers,
  (limitedUsers) => limitedUsers.toSorted((a, b) => (a.name || '').localeCompare(b.name || ''))
);

export const getUser = createSelector(
  getMappedUsers,
  (_, objectId) => objectId,
  (mappedUsers, objectId) => mappedUsers[objectId]
);

export const getUsersLoading = (state) => state.ad.loadingUsers;
export const getLimitedUsersLoading = (state) => state.ad.loadingLimitedUsers ?? true;
